import { Button, Flex, Heading } from '@rocket/ui';
import { useNavigate } from '@tanstack/react-router';
import { PageContent } from '../../components';
import { HOME_ROUTE } from '../../routes.config';

const NotFound = () => {
  const navigate = useNavigate();
  return (
    <PageContent>
      <Flex.V alignItems="center" justifyContent="center" gap="4" p="8">
        <Heading as="h1" size="xl">
          Error 404
        </Heading>
        <Heading as="h2" size="lg">
          Page not found
        </Heading>
        <Button onClick={() => navigate({ to: HOME_ROUTE })}>
          Click to return to the home page
        </Button>
      </Flex.V>
    </PageContent>
  );
};

export default NotFound;
